export default __webpack_public_path__ + "static/media/privacy.31a63b4c.svg";